// extracted by mini-css-extract-plugin
module.exports = {"archiveList":"style_archiveList__jJ3ev","item":"style_item__T_m2l"};